import { utilsConstants } from "@puls/puls-common-constants";

export enum QuoteServiceTypes {
	SERVICE = "SERVICE",
	PART = "PART"
}

export const BaseTypeIds: any = { 
	[QuoteServiceTypes.SERVICE]: utilsConstants.BASE_TYPE_IDS.SERVICE,
	[QuoteServiceTypes.PART]: utilsConstants.BASE_TYPE_IDS.PART
}
